import React, { useRef } from 'react';
import { Col, Collapse, Row } from 'antd';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CollapseCloseIcon from '../../assets/imgs/common/collapse-minus.svg';
import CollapseOpenIcon from '../../assets/imgs/common/expand-plus.svg';
import '../../assets/scss/index.scss';

const CustomFlexLayout = ({
  children,
  className = '',
  carouselLayout = false,
  carouselContent,
  collapseClass,
  flexLeftCol,
  flexBgClass,
  itemsList = [],
  leftFlexlg,
  rightFlexlg,
  activeCollapseKey,
  onCollapseChange,
  ...props
}) => {
  const FlexLayoutClass = classNames('custom-flex-layout-container', className, {});
  const contentRefs = useRef({}); 

  const handleCollapseChange = (key) => {
    if (onCollapseChange) {
      onCollapseChange(key);
    }
    if (key && key.length > 0) {
      const activeKey = key[0];
      const contentRef = contentRefs.current[activeKey];
      if (contentRef) {
        setTimeout(() => {
          contentRef.scrollTop = 0; 
        }, 50);
      }
    }
  };

  // Build items with refs for each panel
  const collapseItems = itemsList.map((item) => ({
    ...item,
    children: (
      <div
        ref={(ref) => {
          if (ref) contentRefs.current[item.key] = ref;
        }}
       className="hide-scrollbar"
      >
        {item.children}
      </div>
    )
  }));

  return (
    <div className={FlexLayoutClass} {...props}>
      <Row className='mt-18 mx-20 custom-flex-layout-row'>
        <Col
          className={flexLeftCol}
          xs={{ flex: '100%' }}
          sm={{ flex: '100%' }}
          md={{ flex: '100%' }}
          lg={{ flex: leftFlexlg }}
          xl={{ flex: leftFlexlg }}
        >
          {carouselLayout ? carouselContent : <div className={flexBgClass}></div>}
        </Col>
        <Col
          className='custom-flex-layout-right-col'
          xs={{ flex: '100%' }}
          sm={{ flex: '100%' }}
          md={{ flex: '100%' }}
          lg={{ flex: rightFlexlg }}
          xl={{ flex: rightFlexlg }}
        >
          {children}
          {carouselLayout && (
            <Collapse
              items={collapseItems}
              ghost
              accordion
              defaultActiveKey={['1']}
              activeKey={activeCollapseKey}
              onChange={handleCollapseChange}
              expandIconPosition='end'
              className={collapseClass}
              expandIcon={({ isActive }) => (
                <img
                  src={isActive ? CollapseCloseIcon : CollapseOpenIcon}
                  alt={isActive ? 'collapse-icon' : 'expand-icon'}
                />
              )}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

CustomFlexLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  carouselLayout: PropTypes.bool,
  carouselContent: PropTypes.node,
  collapseClass: PropTypes.string,
  flexLeftCol: PropTypes.string,
  flexBgClass: PropTypes.string,
  itemsList: PropTypes.array,
  leftFlexlg: PropTypes.string,
  rightFlexlg: PropTypes.string,
  activeCollapseKey: PropTypes.array,
  onCollapseChange: PropTypes.func
};

export default CustomFlexLayout;